<template>
  <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">جزئیات اطلاعات</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13">
              <v-btn
                class="mx-2 mt-3 mr-n16"
                fab
                dark
                small
                color="darkColor"
                @click="backToUsers()"
                elevation="0"
              >
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="68vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row class="mt-2">
                    <span class="part-title-content">اطلاعات اصلی</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in mainInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">اطلاعات تکمیلی</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in otherInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">شهرستان ها</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in cityInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">بیمارستان ها</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in hospitalInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">نقش ها</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in roleInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                  <v-row class="mt-7">
                    <span class="part-title-content">سطح دسترسی ها</span>
                    <v-divider class="mt-3 mr-3"></v-divider>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col v-for="item in permissionInformation" :key="item.id" :cols="item.size">
                      <user-detail-component
                        :title="item.title"
                        :size="item.size"
                        :text="item.text"
                        :icon="item.icon"
                      ></user-detail-component>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import Vue from 'vue';
  import UserDetailComponent from '@/components/UserDetailComponent.vue';
  import AlertComponent from '../../../components/AlertComponent.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import SharedMixin from '@/Mixins/Shared';
  import SharedHelper from '@/Helpers/Shared';
  import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
  export default {
    inject: ['tableImg', 'tableTitleImage'],
    components: {
      UserDetailComponent,
      AlertComponent,
    },
    mixins: [snackBar, SharedMixin, UserMixin, SharedHelper],
    created() {
      this.$root.$refs.UserDetail = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {
        mainInformation: [],
        otherInformation: [],
        roleInformation: [],
        permissionInformation: [],
        hospitalInformation: [],
        cityInformation: [],
      };
    },
    methods: {
      mounte: function () {
        let userId = this.$route.params.id;
        this.getUserDetailFunction(userId);
      },
      backToUsers: function () {
        this.$router.push({ name: 'user' });
      },
      makeDataReady: function (data) {
        let gender = 'مرد';
        let birthDate = '';
        if (data.gender === 1) {
          gender = 'زن';
        }
        if (data.birthDate) {
          birthDate = Vue.moment(data.birthDate).format('jYYYY/jM/jD');
        }
        this.mainInformation.push(
          {
            title: 'نام:',
            icon: 'mdi-account',
            text: data.firstName ? data.firstName : '-',
            id: 1,
            size: 4,
          },
          {
            title: 'نام خانوادگی:',
            icon: 'mdi-account',
            text: data.lastName ? data.lastName : '-',
            id: 2,
            size: 4,
          },
          {
            title: 'جنسیت:',
            icon: 'mdi-human-male-female',
            text: gender,
            id: 3,
            size: 4,
          },
          {
            title: 'تاریخ تولد:',
            icon: 'mdi-calendar-blank',
            text: birthDate ? birthDate : '-',
            id: 4,
            size: 4,
          },
          {
            title: 'کد ملی:',
            icon: 'mdi-card-account-details',
            text: data.nationalCode ? data.nationalCode : '-',
            id: 5,
            size: 4,
          },
          {
            title: 'شماره همراه:',
            icon: 'mdi-phone mdi-flip-h',
            text: data.phoneNumber ? data.phoneNumber : '-',
            id: 6,
            size: 4,
          },
          {
            title: 'سمت:',
            icon: 'mdi-account-cog',
            text:
              data.userPersonnelInfo && data.userPersonnelInfo.organizationRole
                ? data.userPersonnelInfo.organizationRole.title
                : '-',
            id: 7,
            size: 4,
          },
          {
            title: 'شماره پرسنلی:',
            icon: 'mdi-badge-account-horizontal',
            text: data.userPersonnelInfo ? data.userPersonnelInfo.personnelNumber : '-',
            id: 8,
            size: 4,
          },
          {
            title: 'نام کاربری:',
            icon: 'mdi-account',
            text: data.userName ? data.userName : '-',
            id: 10,
            size: 4,
          },
        );
        let expireDate = '';
        if (data.expireDate) {
          expireDate = Vue.moment(data.expireDate).format('jYYYY/jM/jD');
        }
        this.otherInformation.push(
          {
            title: 'مدرک تحصیلی:',
            icon: 'mdi-book-open-page-variant',
            text: data.educationDegree ? data.educationDegree.title : '-',
            id: 1,
            size: 4,
          },
          {
            title: 'انقضای حساب:',
            icon: 'mdi-calendar-blank',
            text: expireDate ? expireDate : '-',
            id: 3,
            size: 4,
          },
          {
            title: 'ایمیل:',
            icon: 'mdi-email',
            text: data.emailAddress ? data.emailAddress : '-',
            id: 4,
            size: 4,
          },
          {
            title: 'آدرس:',
            icon: 'mdi-map-marker',
            text: data.address ? data.address : '-',
            id: 5,
            size: 8,
          },
        );
        let cityData = '';
        for (let i = 0; i < data.cities.length; i++) {
          cityData += data.cities[i].title;
          cityData += ',';
        }
        cityData = this.removeLastCharechter(cityData);
        this.cityInformation.push({
          title: 'شهرستان:',
          icon: 'mdi-home-city',
          text: cityData ? cityData : '-',
          id: 1,
          size: 12,
        });
        let hospitalData = '';
        for (let i = 0; i < data.hospitals.length; i++) {
          hospitalData += data.hospitals[i].title;
          hospitalData += ',';
        }
        hospitalData = this.removeLastCharechter(hospitalData);
        this.hospitalInformation.push({
          title: 'بیمارستان:',
          icon: 'mdi-hospital-building',
          text: hospitalData ? hospitalData : '-',
          id: 1,
          size: 12,
        });
        let roleData = '';
        for (let i = 0; i < data.roles.length; i++) {
          roleData += data.roles[i].persianTitle;
          roleData += ',';
        }
        roleData = this.removeLastCharechter(roleData);
        this.roleInformation.push({
          title: 'نقش:',
          icon: 'mdi-account-cog ',
          text: roleData ? roleData : '-',
          id: 1,
          size: 12,
        });
        let permissionData = '';
        for (let i = 0; i < data.permissions.length; i++) {
          permissionData += data.permissions[i].title;
          permissionData += ',';
        }
        permissionData = this.removeLastCharechter(permissionData);
        this.permissionInformation.push({
          title: 'سطح دسترسی:',
          icon: 'mdi-account-lock',
          text: permissionData ? permissionData : '-',
          id: 1,
          size: 12,
        });
      },
    },
  };
</script>
<style scoped>
  .body-card {
    overflow-y: auto !important;
  }
  .part-title-content {
    font-weight: 600;
    font-size: 14px;
    color: #212121;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
